interface WithId {
  id: number;
}
export const objectToNormalized = <T extends WithId>(obj: T) => ({
  [obj.id]: obj
});
